import React, { useCallback, useMemo } from "react";
import mapValues from "lodash/mapValues";
import { ExpandableCheckboxListItem } from "components/common";
import { Input } from "components/bootstrap";
const CHECKBOX_STATES = {
  Checked: "Checked",
  Empty: "Empty",
  Indeterminate: "Indeterminate"
};
const CheckBoxGroup = ({ groupLabel, checked, onChange, labels }) => {
  const value = useMemo(() => {
    if (Object.values(checked).every((val) => val)) {
      return CHECKBOX_STATES.Checked;
    }
    if (Object.values(checked).some((val) => val)) {
      return CHECKBOX_STATES.Indeterminate;
    }
    return CHECKBOX_STATES.Empty;
  }, [checked]);
  const groupOnChange = useCallback(() => {
    switch (value) {
      case CHECKBOX_STATES.Checked:
        return onChange(mapValues(checked, () => false));
      case CHECKBOX_STATES.Empty:
        return onChange(mapValues(checked, () => true));
      case CHECKBOX_STATES.Indeterminate:
        return onChange(mapValues(checked, () => true));
      default:
        return onChange(mapValues(checked, () => false));
    }
  }, [checked, onChange, value]);
  const itemOnChange = useCallback(
    (key, _) => {
      onChange({
        ...checked,
        [key]: !checked[key]
      });
    },
    [checked, onChange]
  );
  return /* @__PURE__ */ React.createElement(
    ExpandableCheckboxListItem,
    {
      header: groupLabel,
      value: groupLabel,
      checked: value === CHECKBOX_STATES.Checked,
      indeterminate: value === CHECKBOX_STATES.Indeterminate,
      onChange: groupOnChange
    },
    Object.entries(checked).map(([key, isChecked]) => /* @__PURE__ */ React.createElement(
      Input,
      {
        type: "checkbox",
        label: labels[key],
        formGroupClassName: "no-bm",
        key,
        checked: isChecked,
        onChange: (e) => itemOnChange(key, e)
      }
    ))
  );
};
export default CheckBoxGroup;
